const FileSelectorMixin = {
  totalNumberOfFilesSelected() {
    return this.filesSelected().length;
  },

  filesSelected() {
    const { service } = this.props;
    return (this.files || []).map((f) => {
      f.service = service;
      return f;
    });
  },

  // Puts a previously captured selection back - see LoaderBase#handleRetryFailures,
  // which snapshots the failures before the failures view unmounts the sources.
  //
  // This has to be a method rather than an assignment to `files`: a wrapper source
  // such as CombinedLoader keeps its own `files` as a stale snapshot while
  // filesSelected() reads the inner component's list, so assigning to the wrapper
  // restores a list nothing ever uploads from. Handed through setFunctions, this
  // lands on whichever component actually owns the files.
  restoreFiles(files) {
    this.files = files;
  },

  removeFile(file) {
    const index = this.files.indexOf(file);
    if (index === -1) {
      return;
    }

    this.files.splice(index, 1);
    delete file.selected;
  },

  clear() {
    this.files = [];

    if (typeof this._clear === 'function') {
      this._clear();
    }
  },
};

export default FileSelectorMixin;
